/**
<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
**/

/* HPX-351 Start */
(() => {
  const root = document.getElementById('HeaderNavigation');
  if (!root) return;
 
  const open_classes = ['is-open','open','active','hover','a11y-open'];
  const sel_l1_li = '.menu-lv-1.dropdown';
  const sel_l2_li = '.menu-lv-2.dropdown';
 
  const sel_l1_toggle    = ':scope > a.menu-lv-1__action';
  const sel_l1_submenu_1 = ':scope > ul.header__submenu';
  const sel_l1_submenu_2 = ':scope > .menu-dropdown';
 
  const sel_l2_container = ':scope > .site-nav-list-dropdown';
  const sel_l2_toggle    = ':scope > a.menu-lv-2__action';
  const sel_l2_submenu   = ':scope > ul.header__submenu';
 
  function get_submenu_l1(li){
    return li.querySelector(sel_l1_submenu_1) || li.querySelector(sel_l1_submenu_2);
  }
  function get_toggle_l1(li){ return li.querySelector(sel_l1_toggle); }
 
  function get_container_l2(li){ return li.querySelector(sel_l2_container) || li; }
  function get_toggle_l2(li){ return get_container_l2(li).querySelector(sel_l2_toggle); }
  function get_submenu_l2(li){ return get_container_l2(li).querySelector(sel_l2_submenu); }
 
  function apply_open_classes(li){ open_classes.forEach(c => li.classList.add(c)); }
  function remove_open_classes(li){ open_classes.forEach(c => li.classList.remove(c)); }
 
  const isMega = (submenu) => submenu && submenu.matches('.menu-dropdown');
 
  function reflowWhenVisible(submenu){
    requestAnimationFrame(() => {
     
      window.dispatchEvent(new Event('resize'));
 
      if (window.jQuery) {
        try {
          window.jQuery(submenu).find('.slick-initialized').each(function(){
            try { window.jQuery(this).slick('setPosition'); } catch(e){}
          });
        } catch(e){}
      }
 
      submenu.querySelectorAll('[data-masonry]').forEach((g) => {
        const inst = g.masonry || g.Masonry || g._masonry || g.__masonry;
        if (inst && typeof inst.layout === 'function') {
          try { inst.layout(); } catch(e){}
        }
      });
    });
  }
 
  function force_show(el){
    if (!el) return;
    el.hidden = false;
    el.removeAttribute('aria-hidden');
    const cs = getComputedStyle(el);
    if (cs.display === 'none') el.style.display = 'block';
    if (cs.visibility === 'hidden') el.style.visibility = 'visible';
    if (parseFloat(cs.opacity) === 0) el.style.opacity = '1';
  }
  function clear_forced(el){
    if (!el) return;
    el.style.display = '';
    el.style.visibility = '';
    el.style.opacity = '';
    el.style.pointerEvents = '';
  }
 
  function close_li(li){
    const t = get_toggle_l1(li) || get_toggle_l2(li);
    const s = get_submenu_l1(li) || get_submenu_l2(li);
    if (t && s){
      t.setAttribute('aria-expanded','false');
 
      if (isMega(s)){
        s.setAttribute('aria-hidden','true');
       
        if (!s.classList.contains('opacity-0')) s.classList.add('opacity-0');
       
        s.style.visibility = 'hidden';
        clear_forced(s);
      } else {
       
        clear_forced(s);
        s.hidden = true;
        s.setAttribute('aria-hidden','true');
      }
 
      remove_open_classes(li);
    }
  }
 
  function close_siblings(selector, li){
    root.querySelectorAll(selector).forEach(other => { if (other !== li) close_li(other); });
  }
 
  function init_level(selector, get_toggle, get_submenu){
    root.querySelectorAll(selector).forEach((li, i) => {
      const toggle  = get_toggle(li);
      const submenu = get_submenu(li);
      if (!toggle || !submenu) return;
 
      if (!submenu.id) submenu.id = 'submenu-' + selector.replace(/\W+/g,'-') + '-' + i;
 
      toggle.setAttribute('role','button');
      toggle.setAttribute('aria-haspopup','true');
      toggle.setAttribute('aria-expanded','false');
      toggle.setAttribute('aria-controls', submenu.id);
 
      if (isMega(submenu)){
        submenu.setAttribute('aria-hidden','true'); // no 'hidden' attribute
      } else {
        submenu.hidden = true;
        submenu.setAttribute('aria-hidden','true');
      }
 
      function open_menu(focus_first){
        if (li.matches(sel_l1_li)) close_siblings(sel_l1_li, li);
        if (li.matches(sel_l2_li)) close_siblings(sel_l2_li, li);
 
        toggle.setAttribute('aria-expanded','true');
        apply_open_classes(li);
 
        if (isMega(submenu)){
         
          submenu.setAttribute('aria-hidden','false');
 
          submenu.style.visibility = 'visible';
          submenu.style.pointerEvents = 'auto';
          if (submenu.classList.contains('opacity-0')) submenu.classList.remove('opacity-0');
         
          reflowWhenVisible(submenu);
        } else {
          force_show(submenu);
        }
 
        if (focus_first){
          const first = submenu.querySelector('a,button,[tabindex]:not([tabindex="-1"])');
          first && first.focus();
        }
      }
 
      function close_menu(){
        toggle.setAttribute('aria-expanded','false');
 
        if (isMega(submenu)){
          submenu.setAttribute('aria-hidden','true');
          // Restore the theme’s hiding state
          submenu.style.visibility = 'hidden';
          submenu.style.pointerEvents = '';
          if (!submenu.classList.contains('opacity-0')) submenu.classList.add('opacity-0');
          clear_forced(submenu);
        } else {
          clear_forced(submenu);
          submenu.hidden = true;
          submenu.setAttribute('aria-hidden','true');
        }
 
        remove_open_classes(li);
      }
 
      function toggle_menu(focus_first){
        const expanded = toggle.getAttribute('aria-expanded') === 'true';
        expanded ? close_menu() : open_menu(focus_first);
      }
 
      toggle.addEventListener('click', e => { e.preventDefault(); toggle_menu(false); });
 
      // Keyboard on toggle
      toggle.addEventListener('keydown', e => {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open_menu(true); }
        else if (e.key === 'ArrowDown') { e.preventDefault(); open_menu(true); }
        else if (e.key === 'ArrowUp') {
          e.preventDefault(); open_menu(true);
          const items = submenu.querySelectorAll('a,button,[tabindex]:not([tabindex="-1"])');
          items.length && items[items.length - 1].focus();
        } else if (e.key === 'Escape') { e.preventDefault(); close_menu(); toggle.focus(); }
      });
 
      // Keyboard inside submenu
      submenu.addEventListener('keydown', e => {
        const items = Array.from(
          submenu.querySelectorAll('a,button,[tabindex]:not([tabindex="-1"])')
        ).filter(el => !el.disabled && el.offsetParent !== null);
        if (!items.length) return;
 
        if (e.key === 'Escape'){ e.preventDefault(); close_menu(); toggle.focus(); return; }
        const idx = items.indexOf(document.activeElement);
        if (e.key === 'ArrowDown'){ e.preventDefault(); items[(idx + 1) % items.length].focus(); }
        if (e.key === 'ArrowUp'){ e.preventDefault(); items[(idx - 1 + items.length) % items.length].focus(); }
        if (e.key === 'Home'){ e.preventDefault(); items[0].focus(); }
        if (e.key === 'End'){ e.preventDefault(); items[items.length - 1].focus(); }
      });
 
      // Outside click closes
      document.addEventListener('click', e => {
        const expanded = toggle.getAttribute('aria-expanded') === 'true';
        if (expanded && !li.contains(e.target)) close_menu();
      }, true);
 
      // Focus leaving the li closes
      li.addEventListener('focusout', () => {
        requestAnimationFrame(() => { if (!li.contains(document.activeElement)) close_menu(); });
      });
    });
  }
 
  init_level(sel_l1_li, get_toggle_l1, get_submenu_l1);
  init_level(sel_l2_li, get_toggle_l2, get_submenu_l2);
 
  root.querySelectorAll(`${sel_l1_li}, ${sel_l2_li}`).forEach(li => {
    li.addEventListener('mouseenter', () => {
      if (li.matches(sel_l1_li)) close_siblings(sel_l1_li, li);
      if (li.matches(sel_l2_li)) close_siblings(sel_l2_li, li);
    });
  });
})();

/* HPX-351 End */

/* HPX-671 */
document.addEventListener('DOMContentLoaded', function () {
  if (window.innerWidth >= 768) return;

  var mediaView = document.querySelector('[data-view-as]');
  var mediaViewMobile = document.querySelector('[data-view-as-mobile]');
  var productGrid = document.querySelector('.productListing');

  if (!mediaView || !mediaViewMobile || !productGrid) return;

  // ✅ check data-mobile-default
  if (productGrid.dataset.mobileDefault !== "1") return;

  var viewMode = mediaView.querySelector('.icon-mode.active');
  var viewModeMobile = mediaViewMobile.querySelector('.icon-mode.active');

  if (viewMode && viewMode.dataset.col != "1") {
    viewMode.classList.remove('active');
    viewModeMobile?.classList.remove('active');

    mediaView.querySelector('.icon-mode-list')?.classList.add('active');
    mediaViewMobile.querySelector('.icon-mode-list')?.classList.add('active');
  }

  // ✅ remove classes + apply list
  ['column-2', 'column-3', 'column-4', 'column-5', 'productGrid'].forEach(function (cls) {
    if (productGrid.classList.contains(cls)) {
      productGrid.classList.remove(cls);
    }
  });

  productGrid.classList.add('productList');
});
/* HPX-671 */

/* HPX-352 */
document.addEventListener('DOMContentLoaded', function () {
  const summary = document.querySelector('[data-search-menu]');
  const details = summary ? summary.closest('details') : null;
  const stickyHeader = document.querySelector('.shopify-section-header-sticky');

  if (summary && details) {
      summary.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              document.body.classList.add('open_search_menu');
              if (stickyHeader) {
                  stickyHeader.classList.add('sticky-search-menu-open');
                  stickyHeader.style.zIndex = '101';
              }
              details.setAttribute('open', 'true');
            }
        });
   }
});
/* HPX-352 */

/* HPX-352 */
document.addEventListener('DOMContentLoaded', function () {
  const summary = document.querySelector('[data-search-menu]');
  const details = summary ? summary.closest('details') : null;
  const stickyHeader = document.querySelector('.shopify-section-header-sticky');

  if (summary && details) {
      summary.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              document.body.classList.add('open_search_menu');
              if (stickyHeader) {
                  stickyHeader.classList.add('sticky-search-menu-open');
                  stickyHeader.style.zIndex = '101';
              }
              details.setAttribute('open', 'true');
            }
        });
   }
});
/* HPX-352 */

/* HPX-285 start */
// Close popup
$(document).on("click", "#compareClosePopup", function() {
  $("#compareLimitPopup").fadeOut(200);
});

/* HPX-285 End */

/* HPX-515 start */


(function ($) {
  'use strict';

  const controllers = new WeakMap();

  class VariantGroupedGallery {
    constructor(root) {
      this.root = root;
      this.$main = $(root).find('.variant-grouped-hpx-version').first();
      this.$thumbs = $(root).find('.variant-thumbs-hpx-version').first();

      this.index = 0;
      this.mode = '';
      this.timer = null;
      this.destroyed = false;

      this.schedule = () => {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.refresh(), 120);
      };

      this.onImageLoad = (event) => {
        if (
          event.target.tagName === 'IMG' &&
          event.target.closest(
            '.variant-grouped-hpx-version, .variant-thumbs-hpx-version'
          )
        ) {
          this.schedule();
        }
      };

      this.$main.on(
        'afterChange.hpxGallery',
        (event, slick, index) => {
          this.index = index;
          this.syncThumbs();
        }
      );

      // Bound on the container, so Slick rebuilds do not remove it.
      this.$thumbs.on(
        'click.hpxGallery',
        '.productView-thumbnail-link',
        (event) => {
          event.preventDefault();

          const slide = $(event.currentTarget).closest('.slick-slide');
          const index = Number(slide.attr('data-slick-index'));

          if (
            Number.isInteger(index) &&
            this.$main.hasClass('slick-initialized')
          ) {
            this.$main.slick('slickGoTo', index);
          }
        }
      );

      window.addEventListener('resize', this.schedule);
      window.addEventListener('orientationchange', this.schedule);
      root.addEventListener('load', this.onImageLoad, true);

      // Also detects width changes caused by surrounding theme layout.
      if ('ResizeObserver' in window) {
        this.observer = new ResizeObserver((entries) => {
          const widths = entries.map(
            (entry) => Math.round(entry.contentRect.width)
          ).join('|');

          // Ignore height-only changes caused by adaptiveHeight.
          if (widths !== this.lastWidths) {
            this.lastWidths = widths;
            this.schedule();
          }
        });

        this.observer.observe(root);

        const wrapper = this.$thumbs.closest(
          '.productView-thumbnail-wrapper'
        )[0];

        if (wrapper) this.observer.observe(wrapper);
      }

      this.refresh();
    }

    visible($element) {
      return Boolean(
        $element.length &&
        $element[0].getClientRects().length &&
        $element[0].getBoundingClientRect().width > 0
      );
    }

    stop($element) {
      if ($element.hasClass('slick-initialized')) {
        $element.slick('unslick');
      }
    }

    syncThumbs() {
      if (!this.$thumbs.hasClass('slick-initialized')) return;

      const slick = this.$thumbs.slick('getSlick');
      const index = Math.min(this.index, slick.slideCount - 1);

      if (index < 0) return;

      // Scroll the thumbnail strip to keep the selected image visible.
      this.$thumbs.slick('slickGoTo', index, true);

      this.$thumbs
        .find('.productView-thumbnail-link')
        .removeClass('is-active')
        .removeAttr('aria-current');

      this.$thumbs
        .find(`.slick-slide[data-slick-index="${index}"]`)
        .find('.productView-thumbnail-link')
        .addClass('is-active')
        .attr('aria-current', 'true');

      // Preserve themes that style Slick's selected thumbnail class.
      this.$thumbs.find('.slick-slide').removeClass('slick-current');
      this.$thumbs
        .find(`.slick-slide[data-slick-index="${index}"]`)
        .addClass('slick-current');
    }

    refresh() {
      if (this.destroyed || !this.root.isConnected) return;

      const mainVisible = this.visible(this.$main);
      const thumbsVisible = this.visible(this.$thumbs);

      // Explicit boundaries: mobile < 768, tablet < 1280.
      const width = window.innerWidth;
      const layout = width >= 1280 ? 'desktop'
        : width >= 768 ? 'tablet'
        : 'mobile';

      const mode = `${layout}:${mainVisible}:${thumbsVisible}`;

      if (this.$main.hasClass('slick-initialized')) {
        this.index = this.$main.slick('slickCurrentSlide');
      }

      // Cleanly rebuild when orientation or visibility changes.
      if (mode !== this.mode) {
        this.stop(this.$thumbs);
        this.stop(this.$main);
        this.mode = mode;
      }

      if (!mainVisible) return;

      if (!this.$main.hasClass('slick-initialized')) {
        const count = this.$main.children('.productView-image').length;
        if (!count) return;

        this.index = Math.max(0, Math.min(this.index, count - 1));

        this.$main.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: this.index,
          arrows: count > 1,
          dots: false,
          infinite: false,
          adaptiveHeight: true,
          accessibility: true,
          waitForAnimate: false
        });
      }

      if (
        thumbsVisible &&
        !this.$thumbs.hasClass('slick-initialized')
      ) {
        const count = this.$thumbs
          .children('.productView-thumbnail').length;

        if (count) {
          const requested = layout === 'desktop' ? 4
            : layout === 'tablet' ? 5
            : 3;

          const shown = Math.min(requested, count);

          this.$thumbs.slick({
            slidesToShow: shown,
            slidesToScroll: 1,
            arrows: count > shown,
            dots: false,
            infinite: false,
            adaptiveHeight: false,
            focusOnSelect: false,
            accessibility: true,
            vertical: layout === 'desktop',
            verticalSwiping: layout === 'desktop',
            waitForAnimate: false
          });
        }
      }

      this.$main.slick('setPosition');

      if (this.$thumbs.hasClass('slick-initialized')) {
        this.$thumbs.slick('setPosition');
        this.syncThumbs();
      }

      const count = this.$main.slick('getSlick').slideCount;

      this.$main
        .closest('.productView-nav.productView-main-slider')
        .attr('data-media-count', count);
    }

    destroy() {
      this.destroyed = true;
      clearTimeout(this.timer);
      this.observer?.disconnect();

      window.removeEventListener('resize', this.schedule);
      window.removeEventListener('orientationchange', this.schedule);
      this.root.removeEventListener('load', this.onImageLoad, true);

      this.$main.off('.hpxGallery');
      this.$thumbs.off('.hpxGallery');

      this.stop(this.$thumbs);
      this.stop(this.$main);
    }
  }

  window.HPXVariantGallery = {
    mount(root) {
      if (!root || !$.fn.slick) return;

      const existing = controllers.get(root);

      if (existing) {
        existing.refresh();
        return;
      }

      if (!root.querySelector('.variant-grouped-hpx-version')) return;

      controllers.set(root, new VariantGroupedGallery(root));
    },

    destroy(root) {
      controllers.get(root)?.destroy();
      controllers.delete(root);
    }
  };

  function mountWithin(container) {
    if (container.matches?.('[id^="ProductSection-"]')) {
      window.HPXVariantGallery.mount(container);
    }

    container.querySelectorAll('[id^="ProductSection-"]').forEach(
      (root) => window.HPXVariantGallery.mount(root)
    );
  }

  $(function () {
    mountWithin(document);
  });

  document.addEventListener('shopify:section:load', (event) => {
    mountWithin(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    if (event.target.matches?.('[id^="ProductSection-"]')) {
      window.HPXVariantGallery.destroy(event.target);
    }

    event.target.querySelectorAll('[id^="ProductSection-"]').forEach(
      (root) => window.HPXVariantGallery.destroy(root)
    );
  });
})(jQuery);

/* HPX-515 start */


/* HPX-35 start */

document.addEventListener('DOMContentLoaded', function () {
  const el = document.querySelector('.sections-policies-block');
  if (!el) return;

  let originalTop = el.getBoundingClientRect().top + window.pageYOffset;
  let originalHeight = el.offsetHeight;
  let isFixed = false;

  function setFixed(on) {
    if (on && !isFixed) {
      el.classList.add('is-fixed');
      isFixed = true;
    } else if (!on && isFixed) {
      el.classList.remove('is-fixed');
      isFixed = false;
    }
  }

  function evaluate() {
    const y = window.pageYOffset;
    const naturalTop = originalTop;
    const naturalBottom = originalTop + originalHeight;
    
    // At very top of page → not fixed
      if (y <= 0) {
        setFixed(false);
        return;
      }

    if (window.location.pathname === '/')
    {                     
      // If scrolled past the element → not fixed
      if (y > naturalBottom) {
        setFixed(false);
        return;
      }

      // If viewport top is below the element’s top → fix it
      if (y < naturalTop) {
        setFixed(true);
        return;
      }
    } else {

      const viewportBottom = y + window.innerHeight;                  

      // If scrolled past the element → not fixed
      if (y > naturalBottom) {
        setFixed(false);
        return;
      }

      // If viewport bottom is above the element → fix it
      if (viewportBottom <= naturalTop) {
        setFixed(true);
        return;
      }
    }
    // Otherwise → not fixed
    setFixed(false);
  }

  // Recompute geometry on resize
  let resizeTimer;
  function onResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      const wasFixed = isFixed;
      if (wasFixed) el.classList.remove('is-fixed');
      originalTop = el.getBoundingClientRect().top + window.pageYOffset;
      originalHeight = el.offsetHeight;
      if (wasFixed) el.classList.add('is-fixed');
      evaluate();
    }, 120);
  }

  window.addEventListener('scroll', evaluate, { passive: true });
  window.addEventListener('resize', onResize);

  // Initial evaluation
  evaluate();
});

/* HPX-35 end */


/* HPX-348 */
  const maxDuration = 2 * 60 * 1000; // 2 minutes in milliseconds
  const intervalTime = 500; // check every 500ms
  let elapsedTime = 0;

  const checkFlyout = setInterval(() => {
    elapsedTime += intervalTime;

    const flyout = document.querySelector('[data-testid="FLYOUT"]');
    if (flyout) {      
      const firstInput = flyout.querySelector('input');
      const firstname = firstInput.id;
      const inputField = document.getElementById(firstname);      
      if (inputField) {
        inputField.focus(); 
        clearInterval(checkFlyout); // Stop checking once done
      }
    }
    // Stop checking after 2 minutes
    if (elapsedTime >= maxDuration) {
      clearInterval(checkFlyout);
    }
  }, intervalTime);
  
/* HPX-348 */



/* HPX-260 */
const storelist = [
              {
                  storeCode: "CA",
                  storeName: "Canada",
                  storeUrl: "https://ca.hyperx.com/",
                  supportedLanguages: "EN, FR",
                  defaultLanguage: "EN",
                  supportedCurrencies: "CAD",
                  supportedStores: "CA"
              },             
              {
                  storeCode: "US",
                  storeName: "United States",
                  storeUrl: "https://hyperx.com/",
                  supportedLanguages: "EN",
                  defaultLanguage: "EN",
                  supportedCurrencies: "USD",
                  supportedStores: "US"
              },
              {
                  storeCode: "AU",
                  storeName: "Australia",
                  storeUrl: "https://au.hyperx.com/",
                  supportedLanguages: "EN",
                  defaultLanguage: "EN",
                  supportedCurrencies: "AUD",
                  supportedStores: "AU"
              },
              {
                  storeCode: "ROW",
                  storeName: "Global",
                  storeUrl: "https://row.hyperx.com/",
                  supportedLanguages: "EN, AR, DE, ES, ES419, FR, IT, ID, PL, pt-BR, RU, VI, TR, TH, KO, zh-CN, zh-TW, JA",
                  defaultLanguage: "EN",
                  supportedCurrencies: "USD",
                  supportedStores: "AF,AX,AL,DZ,AS,AD,AO,AI,AQ,AG,AR,AM,AW,AT,AZ,BS,BH,BD,BB,BE,BZ,BJ,BM,BT,BO,BQ,BA,BW,BR,IO,BN,BG,BF,BI,KH,CM,CV,KY,CF,TD,CL,CN,CX,CC,CO,KM,CG,CK,CR,CI,HR,CW,CY,CZ,CD,DK,DJ,DM,DO,EC,EG,SV,GQ,ER,EE,ET,FK,FO,FJ,FI,FR,GF,PF,TF,GA,GM,GE,GH,GI,GR,GL,GD,GP,GU,GT,GN,GW,GY,HT,VA,HN,HK,HU,IS,IN,ID,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KR,XK,KW,KG,LA,LV,LB,LS,LR,LI,LT,LU,MO,MK,MG,MW,MY,MV,ML,MT,MH,MQ,MR,MU,YT,MX,FM,MD,MC,MN,ME,MS,MA,MZ,MM,NA,NR,NP,NL,NC,NZ,NI,NE,NG,NU,NF,MP,NO,OM,PK,PW,PS,PA,PG,PY,PE,PH,PN,PL,PT,PR,QA,RE,RO,RW,BL,SH,KN,LC,MF,PM,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SX,SK,SI,SB,ZA,GS,SS,ES,LK,SD,SR,SJ,SZ,SE,CH,TW,TJ,TZ,TH,TL,TG,TK,TO,TT,TN,TR,TM,TC,TV,UG,UA,AE,UM,UY,UZ,VU,VN,VG,VI,WF,EH,ZM,ZW"
              }, 
              {
                  storeCode: "GB",
                  storeName: "United Kingdom",
                  storeUrl: "https://uk.hyperx.com/",
                  supportedLanguages: "EN",
                  defaultLanguage: "EN",
                  supportedCurrencies: "GBP",
                  supportedStores: "GB"
              }, 
              {
                  storeCode: "DE",
                  storeName: "Germany",
                  storeUrl: "https://de.hyperx.com/",
                  supportedLanguages: "DE, EN",
                  defaultLanguage: "DE",
                  supportedCurrencies: "EUR",
                  supportedStores: "DE"
              },
              {
                  storeCode: "FR",
                  storeName: "France",
                  storeUrl: "https://fr.hyperx.com/",
                  supportedLanguages: "EN, FR",
                  defaultLanguage: "FR",
                  supportedCurrencies: "EUR",
                  supportedStores: "FR"
              },
              {
                  storeCode: "Sandbox",
                  storeName: "Sandbox",
                  storeUrl: "https://hyperx-gg.myshopify.com/",
                  supportedLanguages: "EN",
                  defaultLanguage: "EN, DE, FR, IT, ID",
                  supportedCurrencies: "USD",
                  supportedStores: "Sandbox"
              }
          ];
var countryList = [
                {
                    'countrycode':'AR',
                    'countryname': 'Argentina'
                },
                {
                    'countrycode':'AU',
                    'countryname': 'Australia'
                },
                {
                    'countrycode':'BE',
                    'countryname': 'Belgium'
                },
                {
                    'countrycode':'BR',
                    'countryname': 'Brazil'
                },
                {
                    'countrycode':'BG',
                    'countryname': 'Bulgaria'
                },
                {
                    'countrycode':'CA',
                    'countryname': 'Canada'
                },
                
                {
                    'countrycode':'CL',
                    'countryname': 'Chile'
                },
                
                {
                    'countrycode':'CN',
                    'countryname': 'China'
                },
                
                {
                    'countrycode':'CO',
                    'countryname': 'Colombia'
                },
                
                {
                    'countrycode':'CR',
                    'countryname': 'Costa Rica'
                },
                
                {
                    'countrycode':'HR',
                    'countryname': 'Croatia'
                },
                
                {
                    'countrycode':'CZ',
                    'countryname': 'Czech Republic'
                },
                {
                    'countrycode':'DK',
                    'countryname': 'Denmark'
                },
                {
                    'countrycode':'EG',
                    'countryname': 'Egypt'
                },
                {
                    'countrycode':'EE',
                    'countryname': 'Estonia'
                },
                {
                    'countrycode':'FI',
                    'countryname': 'Finland'
                },
                {
                    'countrycode':'FR',
                    'countryname': 'France'
                },
                {
                    'countrycode':'DE',
                    'countryname': 'Germany'
                },
                {
                    'countrycode':'GR',
                    'countryname': 'Greece'
                },
                {
                    'countrycode':'GT',
                    'countryname': 'Guatemala'
                },
                {
                    'countrycode':'HK',
                    'countryname': 'Hong Kong'
                },
                {
                    'countrycode':'HU',
                    'countryname': 'Hungary'
                },
                {
                    'countrycode':'IN',
                    'countryname': 'India'
                },
                {
                    'countrycode':'ID',
                    'countryname': 'Indonesia'
                },
                {
                    'countrycode':'IL',
                    'countryname': 'Israel'
                },
                {
                    'countrycode':'IT',
                    'countryname': 'Italy'
                },
                {
                    'countrycode':'JP',
                    'countryname': 'Japan'
                },
                {
                    'countrycode':'JO',
                    'countryname': 'Jordan'
                },
                {
                    'countrycode':'KZ',
                    'countryname': 'Kazakhstan'
                },
                {
                    'countrycode':'KW',
                    'countryname': 'Kuwait'
                },
                {
                    'countrycode':'LV',
                    'countryname': 'Latvia'
                },
                {
                    'countrycode':'LT',
                    'countryname': 'Lithuania'
                },
                {
                    'countrycode':'MY',
                    'countryname': 'Malaysia'
                },
                {
                    'countrycode':'MX',
                    'countryname': 'Mexico'
                },
                {
                    'countrycode':'NL',
                    'countryname': 'Netherlands'
                },
                {
                    'countrycode':'NZ',
                    'countryname': 'New Zealand'
                },
                {
                    'countrycode':'NO',
                    'countryname': 'Norway'
                },
                {
                    'countrycode':'PE',
                    'countryname': 'Peru'
                },
                {
                    'countrycode':'PH',
                    'countryname': 'Philippines'
                },
                {
                    'countrycode':'PL',
                    'countryname': 'Poland'
                },
                {
                    'countrycode':'PT',
                    'countryname': 'Portugal'
                },
                {
                    'countrycode':'QA',
                    'countryname': 'Qatar'
                },
                {
                    'countrycode':'RO',
                    'countryname': 'Romania'
                },
                {
                    'countrycode':'SA',
                    'countryname': 'Saudi Arabia'
                },
                {
                    'countrycode':'RS',
                    'countryname': 'Serbia'
                },
                {
                    'countrycode':'SG',
                    'countryname': 'Singapore'
                },
                {
                    'countrycode':'SI',
                    'countryname': 'Slovenia'
                },
                {
                    'countrycode':'KR',
                    'countryname': 'South Korea'
                },
                {
                    'countrycode':'ES',
                    'countryname': 'Spain'
                },
                {
                    'countrycode':'SE',
                    'countryname': 'Sweden'
                },
                {
                    'countrycode':'CH',
                    'countryname': 'Switzerland'
                },
                {
                    'countrycode':'TW',
                    'countryname': 'Taiwan Region'
                },
                {
                    'countrycode':'TH',
                    'countryname': 'Thailand'
                },
                {
                    'countrycode':'TR',
                    'countryname': 'Turkey'
                },
                {
                    'countrycode':'UA',
                    'countryname': 'Ukraine'
                },
                {
                    'countrycode':'AE',
                    'countryname': 'United Arab Emirates'
                },
                {
                    'countrycode':'GB',
                    'countryname': 'United Kingdom'
                },
                {
                    'countrycode':'US',
                    'countryname': 'United States'
                },
                {
                    'countrycode':'UY',
                    'countryname': 'Uruguay'
                },
                {
                    'countrycode':'VN',
                    'countryname': 'Vietnam'
                },
  
             ];              
var languageList = [
                {
                    'langcode':'EN',
                    'langname': 'English'
                },
                {
                    'langcode':'AR',
                    'langname': 'Arabic'
                },
                {
                    'langcode':'DE',
                    'langname': 'Deutsch'
                },
                {
                    'langcode':'ES',
                    'langname': 'Español'
                },
                // {
                //     'langcode':'ES419',
                //     'langname': 'Español (LATAM)'
                // },
                {
                    'langcode':'FR',
                    'langname': 'Français'
                },
                {
                    'langcode':'IT',
                    'langname': 'Italiano'
                },
                {
                    'langcode':'ID',
                    'langname': 'Bahasa Indonesia'
                },
                {
                    'langcode':'PL',
                    'langname': 'Polski'
                },
                {
                    'langcode':'pt-BR',
                    'langname': 'Português (Brasil)'
                },
                {
                    'langcode':'RU',
                    'langname': 'Pyccкий'
                },
                {
                    'langcode':'VI',
                    'langname': 'Tiếng Việt'
                },
                {
                    'langcode':'TR',
                    'langname': 'Türkçe'
                },
                {
                    'langcode':'TH',
                    'langname': 'ไทย'
                },
                {
                    'langcode':'KO',
                    'langname': '한국어'
                },
                {
                    'langcode':'zh-CN',
                    'langname': '中文(简体)'
                },
                {
                    'langcode':'zh-TW',
                    'langname': '中文(繁體)'
                },
                {
                    'langcode':'JA',
                    'langname': '日本語'
                }
  
            ];  

          /**
           * Handles the change event when a user selects a different country from the dropdown.
           *
           * @param {HTMLSelectElement} selectElement - The country <select> element that triggered the change.
           */
          function handleCountryChange(selectElement) {
            // Get the selected country code from the dropdown
            const selectedCountry = selectElement.value;             
            if(selectedCountry == 'global') {
              setCustomerLocation('');
            }                                   
            setcustomCountryURL(selectedCountry); 
          }
              

          /**
           * Retrieves the store URL for a given store code.
           *
           * @param {string} storecode - The store code to look up (e.g., "CA", "US").
           * @returns {string} - The corresponding store URL (e.g., "https://ca.hyperx.com/").
           */
          function getsupportedstoreurl(storecode) {
              // If storecode is blank or falsy, return empty string immediately
              if (!storecode || storecode.trim() === "") {
                return "";
              }
              // Find the store object that matches the given store code
              const store = storelist.find(item => item.storeCode === storecode);

              // Return the storeUrl if found, otherwise return empty string
              return store ? store.storeUrl : "";
          }

          
          /**
           * Finds the storeCode that supports a given country code.
           *
           * @param {string} fetchcountrycode - The country code to look for (e.g., "CA", "US").
           * @returns {string} - The storeCode that supports the given country code.
           */
          function getsupportedStores(fetchcountrycode) {
            var i = 0;
            var supportedstorecode = ''; // Initialize the result variable

            // Loop through each store in the storelist
            while (i < storelist.length) {
              // Get the supportedStores string for the current store
              var supportedStores = storelist[i].supportedStores;

              // Split the string into an array of individual country codes
              var supportedStoressplit = supportedStores.split(",");

              // Loop through each supported country code
              for (var g in supportedStoressplit) {
                // Check if the current country code matches the one we're looking for
                if (fetchcountrycode == supportedStoressplit[g]) {
                  // If matched, assign the storeCode of the current store
                  supportedstorecode = storelist[i]['storeCode'];
                }
              }

              // Move to the next store in the list
              i++;
            }

            // If still blank, set default
            if (!supportedstorecode) {
              supportedstorecode = "ROW";
            }

            // Return the matched storeCode (or empty string if not found)
            return supportedstorecode;
          }


          /**
           * Retrieves the supported languages for a given store code.
           *
           * @param {string} storecode - The store code to look up (e.g., "CA", "US").
           * @returns {string} - A comma-separated string of supported language codes (e.g., "EN, FR").
           */
          function getsupportedLanguages(storecode) {
            // Find the store object that matches the given store code
            const store = storelist.find(item => item.storeCode === storecode);

            // Return supportedLanguages if store exists, otherwise return empty string
            return store ? store.supportedLanguages : '';
          }

          /**
           * Retrieves the default language for a given store code.
           *
           * @param {string} storecode - The store code to look up (e.g., "CA", "US").
           * @returns {string} - The default language code for the specified store (e.g., "EN").
           */
          function getdefaultLanguage(storecode) {
              // If storecode is blank or falsy, return empty string immediately
              if (!storecode || storecode.trim() === "") {
                return "";
              }

              // Find the store object that matches the given store code
              const store = storelist.find(item => item.storeCode === storecode);

              // Return the defaultLanguage if found, otherwise return empty string
              return store ? store.defaultLanguage : "";
          }


          /**
           * Constructs and redirects to a localized store URL based on the selected country code.
           *
           * @param {string} countryCode - The selected country code (e.g., "CA", "US").
           */
          function setcustomCountryURL(countryCode) {            
            const storeCode = getsupportedStores(countryCode);
            const storeurl = getsupportedstoreurl(storeCode);
            const defaultlanguage = getdefaultLanguage(storeCode).toLowerCase();

            const storeLang = document.documentElement.getAttribute("lang");
            const currentLanguageCode = storeLang.substring(0, 2).toLowerCase();

            const urlObj = new URL(window.location.href);

            // Build query params
            const params = new URLSearchParams(urlObj.search);
            params.delete("loc");

            // Only add loc if not global
            if (countryCode.toLowerCase() !== "global") {                
                params.append("loc", countryCode);
                setCustomerLocation(countryCode);
            }

            // Normalize language for path usage
            const toPathLang = (codeLower) => {
                if (codeLower === "zh-cn") return "zh-hans";
                if (codeLower === "zh-tw") return "zh-hant";
                if (codeLower === "pt-br") return "pt";
                return codeLower;
            };

            // Get supported languages
            const supportedLanguages = getsupportedLanguages(storeCode)
                .toLowerCase()
                .split(",");

            // Check if current language is supported
            const isCurrentLanguageSupported = supportedLanguages.includes(currentLanguageCode);

            // Fallback to default language if unsupported
            const finalLanguage = isCurrentLanguageSupported
                ? currentLanguageCode
                : defaultlanguage;

            const finalPathLanguage = toPathLang(finalLanguage);
            const defaultPathLanguage = toPathLang(defaultlanguage);

            // Normalize base URL
            const baseUrl = storeurl.endsWith("/")
                ? storeurl.slice(0, -1)
                : storeurl;

            // Get path parts
            let pathParts = urlObj.pathname.split("/").filter(Boolean);

            // Remove existing language prefix
            const isLangSegment = (seg) => {
                if (!seg) return false;

                const s = seg.toLowerCase();

                return (
                    s.length === 2 ||
                    s === "zh-hans" ||
                    s === "zh-hant"
                );
            };

            if (pathParts.length && isLangSegment(pathParts[0])) {
                pathParts.shift();
            }

            // Add language only if not default
            if (finalPathLanguage !== defaultPathLanguage) {
                pathParts.unshift(finalPathLanguage);
            }

            // Construct final URL
            let completeUrl = `${baseUrl}/${pathParts.join("/")}`;

            if (params.toString()) {
                completeUrl += `?${params.toString()}`;
            }

            window.location.href = completeUrl;
          }        

        
window.addEventListener("pageshow", function(event) {
  const params = new URLSearchParams(window.location.search);
  const loc = params.get("loc");    
  const customer_country = getCookie('customer_country');        

  if (loc && customer_country !== loc) {
      // Update cookie and dropdowns
      setCustomerLocation(loc);
  }          
});
         
/* HPX-260 */  
/** HPX-689 Country Modal Start*/
document.addEventListener("DOMContentLoaded", function () {

  function toPathLang(codeLower) {
    if (!codeLower) return "";
    if (codeLower === "zh-cn") return "zh-hans";
    if (codeLower === "zh-tw") return "zh-hant";
    if (codeLower === "pt-br") return "pt";
    return codeLower; // for en, fr, de, etc.
  }

  function isLangSegment(seg) {
    if (!seg) return false;
    const s = seg.toLowerCase();
    // Treat 2-letter codes & zh-hans/zh-hant as language segments
    return s.length === 2 || s === "zh-hans" || s === "zh-hant";
  }

  function initLanguageSelector() {
    const selectors = document.querySelectorAll('.language-selector');
    if (!selectors.length) return;
    selectors.forEach(function (selector) {
      selector.addEventListener('change', function () {
        const url = new URL(window.location.href);
        // 1) Read selected language
        const selectedLangRaw = this.value;                // e.g., "zh-TW" (keep for &lang=)
        const selectedLower   = selectedLangRaw.toLowerCase(); // "zh-tw"
        const selectedPathLang = toPathLang(selectedLower);     // "zh-hant"

        // 2) Country/store & default language
        let countrycode = (getCookie('customer_country') || '').trim();

        if (!countrycode) {
          countrycode = document.getElementById("RedirectCountry")?.value?.trim() || '';
        }
        const storecode = (countrycode && countrycode.toLowerCase() !== 'row')
          ? getstorecode(countrycode)
          : countrycode;

        const defaultLangLower = (getdefaultLanguage(storecode) || '').toLowerCase();
        const defaultPathLang  = toPathLang(defaultLangLower);

        // 3) Path handling — ensure no duplicates and correct first segment
        let segments = url.pathname.split('/').filter(Boolean);

        // Remove any language-like segments beyond index 0
        segments = segments.filter((seg, idx) => !(isLangSegment(seg) && idx !== 0));

        const firstIsLang = segments.length > 0 && isLangSegment(segments[0]);

        if (selectedPathLang === defaultPathLang) {
          // Selected equals default: remove any language segment from path
          if (firstIsLang) segments.shift();
        } else {
          // Selected differs from default: ensure exactly one language at the start
          if (firstIsLang) {
            segments[0] = selectedPathLang;
          } else {
            segments.unshift(selectedPathLang);
          }
        }
        // 4) Cookie (store normalized path lang)
        const currentstorecode = (typeof getCurrentStoreCodeDetails === 'function')
          ? (getCurrentStoreCodeDetails() || '')
          : '';
        setContinueCookie('continueStoreinfo', selectedPathLang + ',' + currentstorecode, 7);
        // 5) Build the new pathname (no forced trailing slash)
        url.pathname = '/' + segments.join('/');

        // 6) Query params: always set loc; lang only when selected==default, else delete it
        const params = url.searchParams;
        if (countrycode) params.set('loc', countrycode);

        if (selectedPathLang === defaultPathLang) {
          // Keep UI selection in the query param (original casing, e.g., "zh-TW")
          params.set('lang', selectedLangRaw);
        } else {
          params.delete('lang');
        }
        url.search = params.toString() ? '?' + params.toString() : '';
        // 7) Redirect
        window.location.href = url.toString();
      });
    });
  }
  initLanguageSelector();
});

document.addEventListener("DOMContentLoaded", function () {

  let currentStoreLang = document.body.getAttribute("lang");
  const currentStoreCode = currentStoreLang.replace(/^.*-/, "").toUpperCase();

  const customer_country = getCookie('customer_country');
  const globeIcon = document.getElementById("icon__globe_country_announcement-bar");
  const globeMobileIcon = document.getElementById("icon__globe_country_Mobile");
  const globeFooterIcon = document.getElementById("icon__globe_country_Footer");

  const countrySelect = document.getElementById("country-selector-announcement-bar");
  const footercountry = document.getElementById("country-selector-Footer");
  const mobilecountry = document.getElementById("country-selector-Mobile");

  if (!customer_country) {
    if (globeIcon) globeIcon.style.display = "flex";
    if (globeMobileIcon) globeMobileIcon.style.display = "flex";
    if (globeFooterIcon) globeFooterIcon.style.display = "flex";
    [countrySelect, footercountry, mobilecountry].forEach(el => {
      if (el) el.value = currentStoreCode;
    });
    return;
  }

  // Hide globe icon if country exists
  if (globeIcon) globeIcon.style.display = "none";
  if (globeMobileIcon) globeMobileIcon.style.display = "none";
  if (globeFooterIcon) globeFooterIcon.style.display = "none";

  const countryValue = customer_country.toUpperCase();

  if (countrySelect) countrySelect.value = countryValue;
  if (footercountry) footercountry.value = countryValue;
  if (mobilecountry) mobilecountry.value = countryValue;

});

document.addEventListener("DOMContentLoaded", function () {
  const params = new URLSearchParams(window.location.search);
  const loc = params.get("loc");

  if (!loc) return; // stop if no loc in URL
  const lloc = loc.toUpperCase(); // convert to uppercase
  if (lloc === 'ROW') {
      lloc = 'global';
  }
  const countrySelect = document.getElementById("country-selector-announcement-bar");
  const footercountry = document.getElementById("country-selector-Footer");
  const mobilecountry = document.getElementById("country-selector-Mobile");  
  if (mobilecountry) {
      mobilecountry.value = lloc;
  }
  if (countrySelect) {
    countrySelect.value = lloc;    
  }
  if (footercountry) {                                
    footercountry.value = lloc;              
  }          
});

function getCurrentStoreCodeDetails() {
  var currentstorecode = getCookie('continueStoreinfo');   
  const cookieArray = currentstorecode.split(",");  
  let storecode     = cookieArray[1];
  return storecode;
}

function allcountrylist() {
  var currentstorecode = getCurrentStoreCodeDetails();            
  if(currentstorecode != null) {                  
      var supportLanguage = getsupportedLanguages(currentstorecode);  
      const supportedlanguage = supportLanguage.split(", ");      
      const defaultlang = getCurrentlanguageCodeDetails();
      buildDropDowns(supportedlanguage, defaultlang); // build new options of language                  
    var currentcountrycode = getsupportedStores(currentstorecode);         
  }
  var options = "";
  options += "<option value='ROW'>Select Country/Region</option>";   
  var customer_country = getCountryCookie("customer_country")
  for (let j = 0; j<countryList.length; j++) {
    var countrycode = countryList[j].countrycode;
    var countryname = countryList[j].countryname;
    if (customer_country && countrycode &&  customer_country.toLowerCase() === countrycode.toLowerCase()) {          
        options += "<option value='" + countrycode + "' selected>" + countryname + "</option>";       
      } else {
        options += "<option value='" + countrycode + "'>" + countryname + "</option>";       
      } 
  }  
    $('#RedirectCountry').html(options);   
}

function buildDropDowns(supportLanguage, defaultlang) {
  var selections = document.getElementsByClassName('languagelist');  

  for (var i = 0; i < selections.length; i++) {
    // Clear existing options first
    selections[i].options.length = 0;

    // Add default "Select Language" option (not selected by default now)
    let defaultOption = createOption('', 'Select Language');
    selections[i].options.add(defaultOption);

    // Loop through supported languages
    for (var j = 0; j < supportLanguage.length; j++) {
      let langindex = languageList.findIndex(
        (item) => item.langcode === supportLanguage[j]
      );

      if (langindex !== -1) {
        let langvalue = languageList[langindex]['langname'];
        let option = createOption(supportLanguage[j], langvalue);

        // Auto-select the default language
        if (supportLanguage[j].toUpperCase() === defaultlang.toUpperCase()) {
          option.selected = true;
        }

        selections[i].options.add(option);
      }
    }
  }
}

function countrySelect() {
  const requestpath = window.location.pathname;
  var countrycode = document.getElementById("RedirectCountry").value;  
  var storecode = getstorecode(countrycode);  
  var supportLanguage = getsupportedLanguages(storecode);  
  var storeurl    = getstoreurl(storecode);
  var defaultlang = getdefaultLanguage(storecode);
  var redirectLink = storeurl + '?loc=' + countrycode + '&lang=' + defaultlang;  

  var selectedlang = document.getElementById("RedirectLanguage").value; 
  const supportedlanguage = supportLanguage.split(", ");  

  if (supportedlanguage.includes(selectedlang)) {
    if (defaultlang == selectedlang) {
      redirectLink = storeurl.replace(/\/$/, '') + requestpath + '?loc=' + countrycode + '&lang=' + selectedlang;
      redirectLink = redirectLink.replace('/' + selectedlang, '');       
    } else {                
      redirectLink = storeurl.replace(/\/$/, '') + requestpath + '?loc=' + countrycode;
    }
  } else {
    // Fallback: use default language if selected is not supported              
    redirectLink = storeurl.replace(/\/$/, '') + requestpath + '?loc=' + countrycode + '&lang=' + defaultlang;              
  }

  // Remove `_gl` parameter if present
  const urlObj = new URL(redirectLink);
  const params = new URLSearchParams(urlObj.search);
  params.delete("_gl"); // strip out unwanted _gl
  redirectLink = urlObj.origin + urlObj.pathname + (params.toString() ? "?" + params.toString() : "");

  // Apply redirect link to form
  $("#RedirectSettings").attr("action", redirectLink);

  $("#RedirectLanguage").empty(); // remove old options    
  buildDropDowns(supportedlanguage, defaultlang); // build new options of language
  languageSelect();
  }

function footersettingsButton() {   
  allcountrylist();
  document.getElementById('choiceContainer').style.display = 'none';
  document.getElementById('settingsContainer').style.display = 'block';
  document.getElementById('back_btn').style.display = 'block';
}

function footerBackButton() {   
  document.getElementById('choiceContainer').style.display = 'block';
  document.getElementById('settingsContainer').style.display = 'none';
  document.getElementById('back_btn').style.display = 'none';
  
}

function getCurrentlanguageCodeDetails() {
  var currentstorecode = getCookie('continueStoreinfo');   
  const cookieArray = currentstorecode.split(",");
  let storelanguage = cookieArray[0].toUpperCase();          
  return storelanguage;          
}

function getcountrycode(fetchcountrycode) {    
    let countryindex     = countryList.findIndex((item) => item.countryname === fetchcountrycode);  
    if (countryindex !== -1) {
       currentcodecode = countryList[countryindex]['countrycode'];
    } else {      
      currentcodecode = 'notexist';
    }
    return currentcodecode;  
}

function getcontinuestoreurl(storecode) {
  const requestpath = window.location.pathname;
  let storeindex  = storelist.findIndex((item) => item.storeCode === storecode);
  let storeurl    = storelist[storeindex]['storeUrl'];
  const fullUrl = window.location.href;
  const urlObj = new URL(fullUrl);
  let pathParts = urlObj.pathname.split("/").filter(Boolean);

  const isLangSegment = (seg) => {
    if (!seg) return false;

    const s = seg.toLowerCase();

    return (
      s.length === 2 ||
      s === "zh-hans" ||
      s === "zh-hant"
    );
  };

  const toPathLang = (codeLower) => {
    if (codeLower === "zh-cn") return "zh-hans";
    if (codeLower === "zh-tw") return "zh-hant";
    if (codeLower === "pt-br") return "pt";

    return codeLower;
  };

  const defaultLanguage = getdefaultLanguage(storecode).toLowerCase();
  const supportedLanguages = getsupportedLanguages(storecode)
    .toLowerCase()
    .split(",")
    .map(lang => lang.trim());

  // Current language from URL
  let currentLanguage = defaultLanguage;

  if (pathParts.length && isLangSegment(pathParts[0])) {
    currentLanguage = pathParts[0].toLowerCase();
    pathParts.shift();
  }

  // Validate against target store
  const finalLanguage = supportedLanguages.includes(currentLanguage) ?
    currentLanguage :
    defaultLanguage;

  const finalPathLanguage = toPathLang(finalLanguage);
  const defaultPathLanguage = toPathLang(defaultLanguage);

  // Add language back only when not default
  if (finalPathLanguage !== defaultPathLanguage) {
    pathParts.unshift(finalPathLanguage);
  }

  const cleanedUrl =
    storeurl +
    pathParts.join("/");
  // Remove existing `loc` parameter while preserving others
  const params = new URLSearchParams(urlObj.search);
  params.delete("loc");
  // Append the new `loc` value
  params.append("loc", countryCode);
  // Remove `_gl` parameter if it exists
  params.delete("_gl");
  // Construct the final corrected URL
  const redirectLink = cleanedUrl.split("?")[0] + "?" + params.toString();
  return redirectLink;
}

function getstorename(storecode) {
  let storeindex     = storelist.findIndex((item) => item.storeCode === storecode);
  let storename    = storelist[storeindex]['storeName'];
  return storename;
}

function getstorecode(fetchcountrycode) {           
  var i = 0;
  var currentstorecode = ""; // initialize as blank

  while (i < storelist.length) {
    var supportedStores = storelist[i].supportedStores;
    var supportedStoressplit = supportedStores.split(",");
    for (var g in supportedStoressplit) {
      if (fetchcountrycode === supportedStoressplit[g].trim()) {          
        currentstorecode = storelist[i]['storeCode'];
      }        
    }              
    i++;
  }

  // If still blank, set default
  if (!currentstorecode) {
    currentstorecode = "ROW";
  }

  return currentstorecode;
}

function languageSelect() {
  const requestpath = window.location.pathname;

  // Remove empty parts
  let segments = requestpath.split("/").filter(s => s !== "");

  const countrycode = document.getElementById("RedirectCountry").value;
  const storecode = (countrycode.toLowerCase() !== "row") ?
    getstorecode(countrycode) :
    countrycode;

  const storeurl = getstoreurl(storecode);

  const selectedLangRaw = document.getElementById("RedirectLanguage").value;
  const selectedLangLower = selectedLangRaw.toLowerCase();

  const toPathLang = (codeLower) => {
    if (codeLower === "zh-cn") return "zh-hans";
    if (codeLower === "zh-tw") return "zh-hant";
    if (codeLower === "pt-br") return "pt";
    return codeLower;
  };

  const defaultLangLower = getdefaultLanguage(storecode).toLowerCase();
  const defaultPathLang = toPathLang(defaultLangLower);

  const supportedLanguages = getsupportedLanguages(storecode)
    .toLowerCase()
    .split(",");

  const isSelectedLanguageSupported = supportedLanguages.includes(selectedLangLower);

  const finalSelectedLangLower = isSelectedLanguageSupported ?
    selectedLangLower :
    defaultLangLower;

  const finalSelectedPathLang = toPathLang(finalSelectedLangLower);

  const isLangSegment = (seg) => {
    if (!seg) return false;
    const s = seg.toLowerCase();
    return s.length === 2 || s === "zh-hans" || s === "zh-hant";
  };

  segments = segments.filter(
    (seg, idx) => !(isLangSegment(seg) && idx !== 0)
  );

  const firstIsLang = segments.length > 0 && isLangSegment(segments[0]);

  if (finalSelectedPathLang === defaultPathLang) {
    if (firstIsLang) {
      segments.shift();
    }
  } else {
    if (firstIsLang) {
      segments[0] = finalSelectedPathLang;
    } else {
      segments.unshift(finalSelectedPathLang);
    }
  }

  const cleanPath = segments.join("/");
  const base = storeurl.replace(/\/+$/, "/");
  const pathPart = cleanPath ? cleanPath.replace(/^\/+/, "") : "";

  const locParam = "loc=" + encodeURIComponent(countrycode);
  const langParam = "lang=" + encodeURIComponent(finalSelectedLangLower);

  let redirectLink;

  if (finalSelectedPathLang === defaultPathLang) {
    redirectLink = base + pathPart + "?" + locParam + "&" + langParam;
  } else {
    redirectLink = base + pathPart + "?" + locParam;
  }

  // Remove `_gl` parameter if present
  const urlObj = new URL(redirectLink);
  const params = new URLSearchParams(urlObj.search);
  params.delete("_gl");
  redirectLink = urlObj.origin + urlObj.pathname + (params.toString() ? "?" + params.toString() : "");
  $("#RedirectSettings").attr("action", redirectLink);
}

function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for(var i=0; i<ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0)==' ') c = c.substring(1);
      if (c.indexOf(name) == 0) return c.substring(name.length,c.length);
  }
  return "";
}

function setContinueCookie(cname, cvalue, exdays, options = {}) {
  // Hide popup (UI concern)
  const el = document.getElementById('popup');
  if (el) el.style.display = 'none';

  // Build attributes
  const expires = new Date(Date.now() + exdays * 24 * 60 * 60 * 1000).toUTCString();
  const path = options.path || '/';                      // <— define cookie Path here
  const domain = options.domain;                         // optional: ".your-root-domain.com"
  const sameSite = options.sameSite || 'Lax';            // Lax | Strict | None
  const secure = options.secure ?? (location.protocol === 'https:'); // default to true on HTTPS

  // Compose the Set-Cookie string
  const parts = [
    `${cname}=${cvalue}`,
    `Expires=${expires}`,
    `Path=${path}`,
    `SameSite=${sameSite}`
  ];
  if (domain) parts.push(`Domain=${domain}`);
  if (secure) parts.push('Secure');

  document.cookie = parts.join('; ');
}

function setCustomerLocation(currentlocation) {
  if(currentlocation.toLowerCase() == 'row'){
      currentlocation = '';
  }
  // Remove special characters, keep only letters, numbers, spaces, and dashes
  const sanitizedLocation = currentlocation.replace(/[^a-zA-Z0-9\s-]/g, '');

  const exdays = 7;
  const newdate = new Date();
  newdate.setTime(newdate.getTime() + (exdays * 24 * 60 * 60 * 1000));
  const expires = "expires=" + newdate.toUTCString();
  document.cookie = "customer_country=" + sanitizedLocation + "; path=/; " + expires;
}

function createOption(optioncode, label) {
  var option     = document.createElement("option");
  option.setAttribute("value", optioncode);
  option.innerHTML = label;  
  return option;
}

function getstoreurl(storeCode) {
  const store = storelist.find(item => item.storeCode === storeCode);
  return store ? store.storeUrl : '';
}

function getCountryCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}
/** HPX-689 Country Modal End*/

/* Start HPX-492 */
function countryNameExists(name) {
  return countryList.some(c => c.countryname.toLowerCase() === name.toLowerCase());
}
/* End HPX-492 */

/* ===== START: CUSTOM SPRINKLR CHAT EVENT ===== */
 
  document.addEventListener('click', (event) => {
        const link = event.target.closest('a[href="#open-sprinklr-chat"]');
        if (!link) return;
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        const chatButton = document.getElementById('chat-button');
        if (chatButton) {
            chatButton.click();
        }
  }, true);
 
/* ===== END: CUSTOM SPRINKLR CHAT EVENT ===== */

/* Start HPX-523 */
document.querySelectorAll("#tab-support-mobile .card-header").forEach(function(header) {
  header.addEventListener("click", function() {
    const collapseId = header.getAttribute("aria-controls");
    const target = document.getElementById(collapseId);
    if (!target) return;

    if (target.classList.contains("support-show")) {
      // Close clicked tab
      target.classList.remove("support-show");
      target.style.maxHeight = "0px";
      header.classList.remove("active");
    } else {
      // Open clicked tab
      header.classList.add("active");
      target.classList.add("support-show");
      target.style.maxHeight = target.scrollHeight + "px";

      target.addEventListener("transitionend", function handler() {
        target.style.maxHeight = "none"; // stable after animation
        target.removeEventListener("transitionend", handler);
      });
    }
  });
});

/* End HPX-523 */